import React from "react";

export default function AdminDialog({ title, children, onClose }) {
  return (
    <div style={overlayStyle}>
      <div style={dialogStyle}>
        <div style={headerStyle}>
          <b>{title}</b>
          <button onClick={onClose}>✕</button>
        </div>

        <div style={contentStyle}>
          {children}
        </div>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999
};

const dialogStyle = {
  background: "#fff",
  borderRadius: 12,
  width: "600px",
  maxHeight: "90vh",
  overflow: "auto",
  padding: "16px"
};

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: 12
};

const contentStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 12
};